import { createInstance } from 'i18next'
import { initReactI18next } from 'react-i18next'
import { matchPath } from 'react-router-dom'

export const DEFAULT_LANG = 'en'

export function createI18n(pathname: string, data: Record<string, any>) {
  const i18nInstance = createInstance()
  const langs = Object.keys(data)
        
  i18nInstance
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      resources: data,
      lng: getStartLang(langs, pathname),

      keySeparator: false, // we do not use keys in form messages.welcome

      interpolation: {
        escapeValue: false, // react already safes from xss
      },
    })
  return i18nInstance
}

export function getLangFromParam(langs:string[], langParam: string) {
  const langParamLower = langParam.toLowerCase()
  // Lang is on of configure...
  if (langs.includes(langParamLower)) {
    return langParamLower
  }
  // Fallback 2 default one
  return DEFAULT_LANG
}

export function getStartLang(langs: string[], pathname: string) {
  const langMatch = matchPath('/:lang/*', pathname)
  if (langMatch) {
    return getLangFromParam(langs, langMatch.params.lang ?? '')
  }
  return DEFAULT_LANG
}
